import React from 'react';
import PropTypes from 'prop-types';
import clxBind from 'classnames/bind';
import styles from './styles.module.scss';

const clx = clxBind.bind(styles);

export default class Alert extends React.Component {
  static propTypes = {
    level: PropTypes.oneOf(['success', 'info', 'warning', 'danger']).isRequired,
    className: PropTypes.string,
    children: PropTypes.node,
  };

  static defaultProps = {
    className: undefined,
    children: null,
  };

  render() {
    const { level, className, children } = this.props;

    const alertClasses = clx(
      'alert',
      {
        [`alert-${level}`]: level,
      },
      className
    );

    return <span className={alertClasses}>{children}</span>;
  }
}
